import React from 'react';
import classNames from 'classnames';

import css from './Paragraph.module.scss';

const Paragraph = ({ paragraphs, type, expand, isFirst, shouldExpand }) => {
	return (
		<>
			{type ? (
				<div
					className={classNames(
						css.paragraph,
						css[type],
						expand && shouldExpand && css[expand],
						expand && isFirst && css.toShow
					)}
				>
					{paragraphs.map(({ id, paragraph }) => (
						<div key={id} className={css.paragraphColumn}>
							<div className={css.wrapper}>{paragraph}</div>
						</div>
					))}
				</div>
			) : (
				<p className={classNames(css[expand], expand && isFirst && css.toShow)}>
					{paragraphs}
				</p>
			)}
		</>
	);
};

export default Paragraph;
